/** Phone + tablet: matches SCSS `isPhone()` / compact layout */
export const COMPACT_LAYOUT_MEDIA = "(max-width: 768px)";

export const isPhoneJs = () => {
  return window.matchMedia(COMPACT_LAYOUT_MEDIA).matches;
};
